import React from "react";
import { Link } from "react-router-dom";
import img1 from "../assets/photos/img1 (1).jpeg";
import img2 from "../assets/photos/img1 (2).jpeg";
import img3 from "../assets/photos/img1 (3).jpeg";

const StatCard = ({ number, label }) => (
  <div className="bg-white rounded-xl p-6 shadow-sm border">
    <div className="text-2xl font-semibold text-gray-800">{number}</div>
    <div className="mt-2 text-sm text-gray-600">{label}</div>
  </div>
);

const FeatureCard = ({ title, desc }) => (
  <div className="bg-white rounded-xl p-6 shadow-sm border hover:shadow-md transition">
    <h4 className="text-lg font-semibold text-gray-800">{title}</h4>
    <p className="mt-3 text-sm text-gray-600">{desc}</p>
  </div>
);

const Home = () => {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-800">
     
      {/* HERO */}
      <section className="bg-white border-b border-gray-200">
        <div className="container mx-auto px-4 py-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <div>
              <p className="inline-block bg-gray-100 text-sm text-gray-700 px-3 py-1 rounded-full mb-4">
                Since 1997 · Tehri Garhwal, Uttarakhand
              </p>

              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight">
                DAREM — Gramin Krishi Vikas Avam Paryavaran Sambhardan Sanstha
              </h1>

              <p className="mt-4 text-lg text-gray-600 max-w-xl">
                Working for rural development and reducing the drudgery of rural
                women, Scheduled Caste and Scheduled Tribe communities in remote
                regions of Uttarakhand. We create sustainable livelihood
                opportunities, improve market linkages, promote rural
                entrepreneurship, and raise social & legal awareness.
              </p>

              <div className="mt-6 flex flex-wrap gap-3">
                <Link
                  to="/donate"
                  className="inline-block bg-blue-600 text-white px-5 py-3 rounded-md text-sm font-semibold shadow-sm hover:bg-blue-700 transition"
                >
                  Donate
                </Link>

                <Link
                  to="/programs"
                  className="inline-block border border-blue-600 text-blue-600 px-5 py-3 rounded-md text-sm font-semibold hover:bg-blue-50 transition"
                >
                  Our Programs
                </Link>
              </div>
            </div>

          <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-200">
  <div className="flex items-start gap-4">
    <div className="p-3 bg-blue-50 rounded-lg">
      <svg
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        className="text-blue-600"
      >
        <path d="M3 12l2-2 4 4L21 4" />
      </svg>
    </div>

    <div>
      <h3 className="text-xl font-semibold text-gray-900">
        Community-led Development
      </h3>
      <p className="mt-2 text-gray-600">
        Field-driven programs, farmer support, self-help groups and
        entrepreneurship for sustained local impact.
      </p>

      <Link
        to="/about"
        className="mt-4 inline-block text-blue-600 font-medium hover:underline"
      >
        Learn more about DAREM →
      </Link>
    </div>
  </div>
</div>

          </div>
        </div>
      </section>

      {/* IMPACT STATS */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <h3 className="text-2xl font-bold text-center mb-8">Our Impact</h3>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
            <div className="bg-gray-50 p-4 text-center">
              <div className="text-2xl font-bold text-primary">50,000+</div>
              <div className="text-sm">Lives Impacted</div>
            </div>
            <div className="bg-gray-50 p-4 text-center">
              <div className="text-2xl font-bold text-primary">15,000+</div>
              <div className="text-sm">Children Reached</div>
            </div>
            <div className="bg-gray-50 p-4 text-center">
              <div className="text-2xl font-bold text-primary">25,000+</div>
              <div className="text-sm">Healthcare Services</div>
            </div>
            <div className="bg-gray-50 p-4 text-center">
              <div className="text-2xl font-bold text-primary">100+</div>
              <div className="text-sm">Communities Served</div>
            </div>
          </div>
        </div>
      </section>

      {/* MISSION */}
      <section className="bg-white border-t border-b border-gray-200">
        <div className="container mx-auto px-4 py-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-2xl font-bold text-gray-900">Our Mission</h2>
              <p className="mt-4 text-gray-600">
                To empower rural communities in Uttarakhand by creating
                opportunities for employment, market connectivity and
                entrepreneurship; improving nutritional standards; and raising
                education, social and legal awareness — with special focus on
                reducing the drudgery of rural women and uplifting SC/ST groups.
              </p>

              <div className="mt-6 space-y-3">
                <p className="text-sm text-gray-600">
                  We combine local knowledge with technical guidance and
                  partnerships to design solutions that last.
                </p>
                <div className="flex gap-3 mt-4">
                  <Link
                    to="/programs"
                    className="inline-block bg-blue-50 text-blue-700 px-4 py-2 rounded-md text-sm font-medium border border-blue-100 hover:bg-blue-100 transition"
                  >
                    View Programs
                  </Link>
                  <Link
                    to="/contact"
                    className="inline-block text-sm text-gray-700 px-4 py-2 rounded-md hover:underline"
                  >
                    Contact Us
                  </Link>
                </div>
              </div>
            </div>

            <div>
              <div className="grid grid-cols-2 gap-4">
                <FeatureCard
                  title="Women Empowerment"
                  desc="Reduce drudgery and create livelihood pathways through SHGs and skills training."
                />
                <FeatureCard
                  title="Sustainable Agriculture"
                  desc="Promote climate-smart, resource-efficient agricultural practices for smallholders."
                />
                <FeatureCard
                  title="Market Linkages"
                  desc="Connect producers with markets to improve incomes and value-capture."
                />
                <FeatureCard
                  title="Awareness & Education"
                  desc="Social, legal and nutritional awareness campaigns for long-term change."
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WORKING AREA */}
      <section className="container mx-auto px-4 py-16">
        <div className="text-center max-w-3xl mx-auto">
          <p className="text-sm font-medium text-blue-600 uppercase tracking-wide">Our Reach</p>
          <h3 className="mt-3 text-2xl font-bold text-gray-900">Serving Uttarakhand's Remote Regions</h3>
          <p className="mt-4 text-gray-600">
            Operating across multiple districts with integrated development programs,
            prioritizing remote and underserved communities.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          <div className="bg-white rounded-xl p-6 border shadow-sm text-center">
            <div className="text-4xl font-semibold text-gray-800">13</div>
            <div className="mt-2 text-sm text-gray-600">Districts Covered</div>
            <p className="mt-3 text-sm text-gray-500">Focus on remote villages and hamlets</p>
          </div>

          <div className="lg:col-span-2 bg-white rounded-xl p-6 border shadow-sm">
            <h4 className="text-lg font-semibold text-gray-900">Core Focus Areas</h4>
            <div className="mt-4 flex flex-wrap gap-3">
              {[
                "Women's Empowerment",
                "Sustainable Agriculture",
                "Rural Development",
                "Community Engagement",
              ].map((t) => (
                <span
                  key={t}
                  className="px-3 py-1 bg-gray-100 rounded-full text-sm text-gray-700 border"
                >
                  {t}
                </span>
              ))}
            </div>

            <h4 className="mt-6 text-lg font-semibold text-gray-900">Key Initiatives</h4>
            <div className="mt-3 flex flex-wrap gap-3">
              {[
                "Employment Generation",
                "Market Connectivity",
                "Rural Entrepreneurship",
                "Education & Awareness",
              ].map((t) => (
                <span
                  key={t}
                  className="px-3 py-1 bg-gray-50 rounded-full text-sm text-gray-700 border"
                >
                  {t}
                </span>
              ))}
            </div>

            <div className="mt-6">
              <Link to="/about" className="text-blue-600 font-medium hover:underline">
                View All Sectors →
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* PROGRAMS */}
      <section className="bg-white border-t border-b border-gray-200">
        <div className="container mx-auto px-4 py-16">
          <div className="text-center max-w-3xl mx-auto">
            <p className="text-sm font-medium text-blue-600 uppercase tracking-wide">What We Do</p>
            <h3 className="mt-3 text-2xl font-bold text-gray-900">Our Core Programs</h3>
            <p className="mt-4 text-gray-600">
              Integrated development programs creating sustainable change across rural Uttarakhand.
            </p>
          </div>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              {
                title: "Women's Empowerment",
                desc: "Self-help groups, leadership programs and skill training for economic independence.",
              },
              {
                title: "Sustainable Agriculture",
                desc: "Organic farming, water conservation and productivity improvement for smallholders.",
              },
              {
                title: "Rural Development",
                desc: "Community infrastructure, livelihoods and social awareness initiatives.",
              },
            ].map((p) => (
              <div key={p.title} className="bg-white rounded-xl p-6 border shadow-sm">
                <h4 className="text-lg font-semibold text-gray-900">{p.title}</h4>
                <p className="mt-3 text-gray-600 text-sm">{p.desc}</p>
                <div className="mt-6">
                  <Link to="/programs" className="text-blue-600 font-medium hover:underline">
                    Learn More →
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CALL TO ACTION */}
      <section className="container mx-auto px-4 py-16">
        <div className="bg-blue-600 text-white rounded-xl p-8 shadow-sm flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h4 className="text-xl font-bold">Join Us in Making a Difference</h4>
            <p className="mt-2 text-sm text-white/90 max-w-xl">
              Support our programs — donate, volunteer, or partner with us to scale impact.
            </p>
          </div>

          <div className="flex gap-3">
            <Link to="/donate" className="bg-white text-blue-600 px-4 py-2 rounded-md font-medium">
              Donate Now
            </Link>
            <Link to="/contact" className="border border-white text-white px-4 py-2 rounded-md font-medium hover:bg-white/10">
              Get Involved
            </Link>
          </div>
        </div>
      </section>

      {/* APEATO (SOCIAL ENTERPRISE) */}
      <section className="bg-gray-50 border-t border-b border-gray-200">
        <div className="container mx-auto px-4 py-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <p className="text-sm font-medium text-blue-600 uppercase tracking-wide">Our Social Enterprise</p>
              <h3 className="mt-3 text-2xl font-bold text-gray-900">Apeato — Social Enterprise Initiative</h3>
              <p className="mt-4 text-gray-600">
                Apeato is our social enterprise that generates sustainable revenue for DAREM programs.
                Revenue from Apeato supports community projects while providing quality products sourced from local producers.
              </p>

              <div className="mt-6 flex gap-3">
                <a
                  href="https://apeato.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-blue-600 text-white px-4 py-2 rounded-md text-sm font-medium"
                >
                  Visit Apeato
                </a>

                <Link to="/about" className="inline-block text-sm text-gray-700 px-4 py-2 rounded-md hover:underline">
                  Learn how Apeato supports DAREM →
                </Link>
              </div>
            </div>

            <div>
              <div className="bg-white rounded-2xl p-6 border shadow-sm text-center">
                <img
                  src="https://res.cloudinary.com/djwtbym2y/image/upload/v1763643861/colored-logo_kndmll.png"
                  alt="Apeato by Bugyal Foods"
                  className="mx-auto h-28 object-contain"
                  loading="lazy"
                />
                <p className="mt-4 text-sm text-gray-600">A social enterprise by Bugyal Foods</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-white border-t border-gray-200">
        <div className="container mx-auto px-4 py-8 text-sm text-gray-600 flex flex-col md:flex-row items-center justify-between gap-4">
          <div>
            © {new Date().getFullYear()} DAREM. All rights reserved.
          </div>

          <div className="flex gap-4">
            <a href="https://darimindia.org/" target="_blank" rel="noopener noreferrer" className="hover:underline">Website</a>
            <a href="tel:+918979151025" className="hover:underline">+91 8979151025</a>
            <a href="/privacy" className="hover:underline">Privacy</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
